import {useCallback, useState} from 'react';
import {createPortal} from 'react-dom';
import {HamburgerMenuDrawer} from '~/common/components/MegaNav/MegaNavVariant/components/HamburgerMenu/components/HamburgerMenuDrawer/HamburgerMenuDrawer';
import {Button} from '~library/atoms/Button';
import {useTracking} from '~library/context/tracking/tracking-context';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {HamburgerMenuIcon} from '~library/svg/v2/HamburgerMenuIcon';

type HamburgerMenuProps = {
  ratio?: number;
};

export const HamburgerMenu = ({ratio = 1}: HamburgerMenuProps) => {
  const isLargishAndUp = useIsLargishAndUp();
  const [isOpen, setIsOpen] = useState(false);
  const {track} = useTracking();

  const openDrawer = useCallback(() => {
    track({
      dataQaId: 'hamburger-menu',
    });
    setIsOpen(true);
  }, [track]);

  const closeDrawer = useCallback(() => setIsOpen(false), []);

  if (isLargishAndUp) {
    return null;
  }

  return (
    <>
      <Button data-qa-id="hamburger-menu" variant="unstyled-button" onClick={openDrawer}>
        <HamburgerMenuIcon ratio={ratio} />
      </Button>
      {createPortal(<HamburgerMenuDrawer open={isOpen} closeNav={closeDrawer} />, document.body)}
    </>
  );
};
